import React from "react";
import PageContainer from "../layouts/PageContainer";
import Dashboard from "../views/Dashboard/Dashboard";
import { createRoute } from "./helpers";

const appRoutes = {
  path: "/",
  element: <PageContainer />,
  children: [
    // Dashboard
    {
      index: true,
      element: <Dashboard />,
    },

    // Setup routes
    createRoute("setup/partner-estate", "Dashboard/PartnerEstate"),
    createRoute("partner-invite", "Dashboard/PartnerInvite"),
    createRoute("setup/family-offer", "Auth/FamilyWillOffer"),
    createRoute("setup/progress", "Dashboard/Progress"),
    createRoute("setup/complete", "Summary/SetupComplete"),

    // Family routes
    createRoute("family/progress", "Family/FamilyProgress"),
    createRoute("family/partners-name", "Family/PartnerName"),
    createRoute("family/partners-plan", "Family/PartnerWillPlan"),
    createRoute("family/partners-email", "Family/PartnerEmail"),
    createRoute("family/partners-gender", "Family/PartnerGender"),
    createRoute("family/basics", "Family/FamilyBasics"),
    createRoute("family/pets", "Family/FamilyPets"),
    createRoute("family/complete", "Family/FamilyComplete"),

    // Guardians routes
    createRoute("guardians/progress", "Guardians/GuardiansProgress"),
    createRoute("guardians/pets", "Guardians/PetsGuardians"),
    createRoute("guardians/pets/alternate", "Guardians/AltPetsGuardians"),
    createRoute("guardians/children", "Guardians/ChildrenGuardians"),
    createRoute("guardians/children/alternate", "Guardians/AltChildrenGuardians"),
    createRoute("guardians/married-with-children", "Guardians/MarriedWithChildrenGuardians"),
    createRoute("guardians/married-with-children/alternate", "Guardians/AltMarriedWithChildrenGuardians"),
    createRoute("guardians/complete", "Guardians/GuardiansComplete"),

    // Executor routes
    createRoute("executor/progress", "Executor/ExecutorProgress"),
    createRoute("executor/set-partner", "Executor/SetPartnerExecutor"),
    createRoute("executor/set-executor", "Executor/SetExecutor"),
    createRoute("executor/partner-co-executor", "Executor/PartnerCoExecutor"),
    createRoute("executor/alt-executor", "Executor/AltExecutor"),
    createRoute("executor/complete", "Executor/Complete"),

    // POA (Power of Attorney) routes
    createRoute("poa/progress", "POA/POAProgress"),
    createRoute("poa/set-partner", "POA/SetPartnerAsPowerOfAttorney"),
    createRoute("poa/partner-co-poa", "POA/PartnerCoPowerOfAttorney"),
    createRoute("poa/set-poa", "POA/SetPowerOfAttorney"),
    createRoute("poa/alt-poa", "POA/AltPowerOfAttorney"),
    createRoute("poa/complete", "POA/Complete"),

    // POA Care routes
    createRoute("poa/care/progress", "POACare/POAProgress"),
    createRoute("poa/care/set-partner", "POACare/SetPartnerAsPowerOfAttorney"),
    createRoute("poa/care/partner-co-poa", "POACare/PartnerCoPowerOfAttorney"),
    createRoute("poa/care/set-poa", "POACare/SetPowerOfAttorney"),
    createRoute("poa/care/alt-poa", "POACare/AltPowerOfAttorney"),
    createRoute("poa/care/cpr-decision", "POACare/CPRDecision"),
    createRoute("poa/care/complete", "POACare/Complete"),

    // Distribution routes
    createRoute("distribution/progress", "Distribution/DistributionProgress"),
    createRoute("distribution/donations-list", "Distribution/DonationList"),
    createRoute("distribution/partner-remaining-assets", "Distribution/PartnerRemainingAssets"),
    createRoute("distribution/partner-backup-plan", "Distribution/PartnerBackupPlan"),
    createRoute("distribution/partner-included-remaining-assets", "Distribution/PartnerIncludedRemainingAssets"),
    createRoute("distribution/pet-guardian-allocation", "Distribution/PetGuardianAllocation"),
    createRoute(
      "distribution/remaining-assets",
      "Distribution/RemainingAssets",
    ),
    createRoute(
      "distribution/beneficiary-death",
      "Distribution/BeneficiaryDeath",
    ),
    createRoute("distribution/entitlement-age", "Distribution/AgeEntitlement"),
    createRoute("distribution/specify-item", "Distribution/SpecifyItem"),
    createRoute("distribution/specific/items", "Distribution/SpecialItemsList"),
    createRoute("distribution/complete", "Distribution/Complete"),
    createRoute("distribution/donations", "Distribution/Donations"),

    // Basic info routes
    createRoute("basic/set-name", "Basics/RegisterName"),
    createRoute("setup/incapacity", "Basics/RegisterIncapacity"),
    createRoute("basic/country", "Basics/Country"),
    createRoute("basic/marital-status", "Basics/MaritalStatus"),
    createRoute("basic/dob", "Basics/DateOfBirth"),
    createRoute("basic/location", "Basics/Location"),
    createRoute("basic/gender", "Basics/Gender"),
    createRoute("basic/pets", "Basics/Pets"),
    createRoute("basic/complete", "Basics/Complete"),
    createRoute("basic/progress", "Basics/BasicProgress"),

    createRoute("documents/finalize-will", "Documents/FinalizeWill"),
    createRoute("documents/ready-to-print", "Documents/ReadyToPrint"),
    createRoute("documents/checkout", "Documents/Checkout"),
    createRoute("documents/incomplete", "Documents/Incomplete"),
    createRoute("documents", "Documents/Documents"),

    // Summary & Account routes
    createRoute("summary", "Summary/Summary"),
    createRoute("account", "Account/Account"),
    createRoute("account/my-plans", "MyPlans/MyPlans"),
    createRoute("account/my-settings", "Settings/Settings"),
    createRoute("account/my-contacts", "MyContacts/MyContacts"),
    createRoute("cancel-deletion/:token", "Auth/CancelAccountDeletion"),
  ],
};

export default appRoutes;
